import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Activity, Category, Code, Company, DocumentLibrary, JobType, Label, LabelType, Postcode, PriceBook, Priority, SecurityRoleType, TokenUser, Zone, TaxRate, TaxRateType, TaxInclusiveOption, State, TechnicianPicker, RoleEntity, Contact, UoM, AssetType } from '@jms/model';
import { CodePriceSearcher } from '@jms/tenant/module.jms.core.data/src/searchers/code.price.searcher';
import { CoreDataContextService } from '../services/core.data.context.service';
import { CoreDataSearcher } from './core.data.searcher';
import { PostcodeSearcher } from './postcode.searcher';
import { DefaultPricebookSearcher, PricebookSearcher } from './pricebook.searcher';
import { UserSearcher } from './user.searcher';

@Injectable()
export class CoreDataSearchers {
    private store: any = {};
    private api = '/api';

    constructor(
        private http: HttpClient,
        private context: CoreDataContextService) { }

    private getSearcher<T>(key: string, func: () => T): T {
        if (!this.store[key]) this.store[key] = func();

        return this.store[key];
    }

    public getCategorySearch(existing: () => Category[] = () => []): CoreDataSearcher<Category> {
        return this.getSearcher(
            'getCategorySearch',
            () => new CoreDataSearcher<Category>(this.http, this.api + '/categories', true, existing)
        );
    }

    public getUoMSearch(existing: () => UoM[] = () => []): CoreDataSearcher<UoM> {
        return this.getSearcher(
            'getIoMSearch',
            () => new CoreDataSearcher<UoM>(this.http, this.api + '/uom', true, existing)
        );
    }

    public getJobTypeSearch(existing: () => JobType[] = () => []): CoreDataSearcher<JobType> {
        return this.getSearcher(
            'JobTypeSearch',
            () => new CoreDataSearcher<JobType>(this.http, this.api + '/jobtypes', true, existing)
        );
    }

    public getLabelSearch(type: LabelType, includeSystemTags: boolean = false, existing: () => Label[] = () => []): CoreDataSearcher<Label> {
        let url = this.api + '/label/tag/' + type;
        if (includeSystemTags) {
            url = `${url}?includeSystemTags=true`
        }

        return this.getSearcher(
            `LabelSearch-${type}`,
            () => new CoreDataSearcher<Label>(this.http, url, true, existing)
        );
    }

    public getPrioritiesSearch(existing: () => Priority[] = () => []): CoreDataSearcher<Priority> {
        return this.getSearcher(
            'PrioritiesSearch',
            () => new CoreDataSearcher<Priority>(this.http, this.api + '/priorities', true, existing)
        );
    }

    public getIncomeTaxRateSearch(existing: () => TaxRate[] = () => []): CoreDataSearcher<TaxRate> {
        return this.getSearcher(
            'IncomeTaxRateSearch',
            () => new CoreDataSearcher<TaxRate>(this.http, this.api + '/tax/rate/picker/' + TaxRateType.Income, true, existing)
        );
    }

    public getExpenseTaxRateSearch(existing: () => TaxRate[] = () => []): CoreDataSearcher<TaxRate> {
        return this.getSearcher(
            'ExpenseTaxRateSearch',
            () => new CoreDataSearcher<TaxRate>(this.http, this.api + '/tax/rate/picker/' + TaxRateType.Expense, true, existing)
        );
    }

    public getZoneSearch(existing: () => Zone[] = () => []): CoreDataSearcher<Zone> {
        return this.getSearcher(
            'ZoneSearch',
            () => new CoreDataSearcher<Zone>(this.http, this.api + '/zones', true, existing)
        );
    }

    public getStateSearch(existing: () => Zone[] = () => []): CoreDataSearcher<State> {
        return this.getSearcher(
            'StateSearch',
            () => new CoreDataSearcher<State>(this.http, this.api + '/postcodes/states', true, existing)
        );
    }

    public getUserSearch(existing: () => TokenUser[] = () => []): CoreDataSearcher<TokenUser> {
        return this.getSearcher(
            'getUserSearch',
            () => new CoreDataSearcher<TokenUser>(this.http, this.api + '/picker/users', true, existing)
        );
    }

    // public getOwnerSearch(existing: () => TokenUser[] = () => []): CoreDataSearcher<TokenUser> {
    //     return this.getSearcher(
    //         'getOwnerSearch',
    //         () => new CoreDataSearcher<TokenUser>(this.http, this.api + '/users/owners', true, existing)
    //     );
    // }

    // public getUserSearchBySecurity(existing: () => TokenUser[] = () => []): UserSearcher {
    //     return this.getSearcher(
    //         'getUserSearchBySecurity',
    //         () => new UserSearcher(this.http, this.api + '/users/security', true, false, [SecurityRoleType.EmployeeTechnician], existing)
    //     );
    // }

    // public getTechnicanSearch(existing: () => TokenUser[] = () => []): UserSearcher {
    //     return this.getSearcher(
    //         'getTechnicanSearch',
    //         () => new UserSearcher(this.http, this.api + '/users/security', true, false, [SecurityRoleType.EmployeeTechnician, SecurityRoleType.SubcontractorAdministrator, SecurityRoleType.SubcontractorUser], existing)
    //     );
    // }

    // public getSubcontractorUserSearchBySecurity(existing: () => TokenUser[] = () => []): UserSearcher {
    //     return this.getSearcher(
    //         'getSubcontractorUserSearchBySecurity',
    //         () => new UserSearcher(this.http, this.api + '/users/security', true, false, [SecurityRoleType.SubcontractorAdministrator, SecurityRoleType.SubcontractorUser], existing)
    //     );
    // }

    // public getSubcontractorUserSearchForPricebooks(existing: () => TokenUser[] = () => []): UserSearcher {
    //     return this.getSearcher(
    //         'getSubcontractorUserSearchBySecurity',
    //         () => new UserSearcher(this.http, this.api + '/users/security', true, true, [SecurityRoleType.SubcontractorAdministrator, SecurityRoleType.SubcontractorUser], existing)
    //     );
    // }

    // public getSubcontractorEmployeeSearch(existing: () => TokenUser[] = () => []): UserSearcher {
    //     return this.getSearcher(
    //         'getSubcontractorEmployeeSearch',
    //         () => new UserSearcher(this.http, this.api + '/users/security', true, false, [SecurityRoleType.SubcontractorUser], existing)
    //     );
    // }

    // public getCustomerPriceBookSearch(existing: () => PriceBook[] = () => []): PricebookSearcher {
    //     return this.getSearcher(
    //         'CustomerPriceBookSearch',
    //         () => new PricebookSearcher(this.http, this.api + '/pricebooks/customer', true, existing)
    //     );
    // }

    // public getTechnicianPricebookSearch(existing: () => PriceBook[] = () => []): PricebookSearcher {
    //     return this.getSearcher(
    //         'TechnicianPriceBookSearch',
    //         () => new PricebookSearcher(this.http, this.api + '/pricebooks/technician', true, existing)
    //     );
    // }

    public getGlobalBuyPriceBookSearch(existing: () => PriceBook[] = () => []): PricebookSearcher {
        return this.getSearcher(
            'GlobalBuyPriceBookSearch',
            () => new PricebookSearcher(this.http, this.api + '/picker/pricebooks/global/buy', true, existing)
        );
    }

    public getGlobalSellPricebookSearch(existing: () => PriceBook[] = () => []): PricebookSearcher {
        return this.getSearcher(
            'getGlobalSellPricebookSearch',
            () => new PricebookSearcher(this.http, this.api + '/picker/pricebooks/global/sell', true, existing)
        );
    }

    public getDefaultPriceBookSearch(): DefaultPricebookSearcher {
        return this.getSearcher(
            'DefaultPriceBookSearch',
            () => new DefaultPricebookSearcher(this.http, this.api + '/pricebooks/default/')
        );
    }

    public getCustomerSearch(existing: () => Contact[] = () => []): CoreDataSearcher<Contact> {
        return this.getSearcher(
            'CustomerSearch',
            () => new CoreDataSearcher<Contact>(this.http, this.api + '/picker/contact/customer/search', true, existing)
        );
    }

    public getCustomerSearchFilter(existing: () => Contact[] = () => []): CoreDataSearcher<Contact> {
        return this.getSearcher(
            'CustomerSearch',
            () => new CoreDataSearcher<Contact>(this.http, this.api + '/picker/contact/customer/search', true, existing)
            //() => new CoreDataSearcher<Contact>(this.http, this.api + '/contacts/customer', true, existing)
        );
    }

    // public getContactsByType(type: CustomerCreatedType, existing: () => Customer[] = () => []): CoreDataSearcher<Customer> {
    //     return this.getSearcher(
    //         'Contacts',
    //         () => new CoreDataSearcher<Customer>(this.http, this.api + `/customers/type`, true, existing, { type: type })
    //     );
    // }

    // public getCustomerSupervisorSearch(): CustomerSupervisorSearcher {
    //     return this.getSearcher(
    //         'getCustomerSupervisorSearch',
    //         () => new CustomerSupervisorSearcher(this.http, this.api + '/customers/supervisors', true)
    //     );
    // }

    public getCodeSearch(existing: () => Code[] = () => []): CoreDataSearcher<Code> {
        return this.getSearcher(
            'CodeSearch',
            () => new CoreDataSearcher<Code>(this.http, this.api + '/codes/item', true, existing)
        );
    }

    public getCodeByCategorySearch(existing: () => Code[] = () => []): CoreDataSearcher<Code> {
        return this.getSearcher(
            'CodeByCategorySearch',
            () => new CoreDataSearcher<Code>(this.http, this.api + '/codes/bycategory', true, existing)
        );
    }

    public getCodeCategoriesSearch(existing: () => Category[] = () => []): CoreDataSearcher<Category> {
        return this.getSearcher(
            'CodeCategoriesSearch',
            () => new CoreDataSearcher<Category>(this.http, this.api + '/codes/categories/', true, existing)
        );
    }

    public getPostcodeSearch(existing: () => Postcode[] = () => []): PostcodeSearcher {
        return this.getSearcher(
            'PostcodeSearch',
            () => new PostcodeSearcher(this.http, this.api + '/postcodes', true, existing)
        );
    }

    public getCompanySearch(existing: () => Company[] = () => []): CoreDataSearcher<Company> {
        return this.getSearcher(
            'CompanySearch',
            () => new CoreDataSearcher<Company>(this.http, this.api + '/picker/companies', true, existing)
        );
    }

    public getActivitySearch(existing: () => Activity[] = () => []): CoreDataSearcher<Activity> {
        return this.getSearcher(
            'ActivitySearch',
            () => new CoreDataSearcher<Activity>(this.http, this.api + '/activities', true, existing)
        );
    }

    public getCodePriceSearch(): CodePriceSearcher {
        return this.getSearcher(
            'CodePriceSearch',
            () => new CodePriceSearcher(this.http, this.api + '/codes/prices')
        );
    }

    public getDocumentSearch(existing: () => DocumentLibrary[] = () => []): CoreDataSearcher<DocumentLibrary> {
        return this.getSearcher(
            'getDocumentSearch',
            () => new CoreDataSearcher<DocumentLibrary>(this.http, this.api + '/documentlibrary', true, existing)
        );
    }

    public getSchedulerSearch(existing: () => TokenUser[] = () => []): CoreDataSearcher<TokenUser> {
        return this.getSearcher(
            'getSchedulerUsers',
            () => new CoreDataSearcher<TokenUser>(this.http, this.api + '/users/resources', true, existing)
        );
    }

    public getTaxInclusiveOption(existing: () => TokenUser[] = () => []): CoreDataSearcher<TaxInclusiveOption> {
        return this.getSearcher(
            'getTaxInclusiveOption',
            () => new CoreDataSearcher<TaxInclusiveOption>(null, null, true, existing)
        );
    }

    public getTechniciansPicker(existing: () => TechnicianPicker[] = () => []): UserSearcher {
        return this.getSearcher(
            'TechnicansPicker',
            () => new UserSearcher(this.http, this.api + '/picker/technicians', true, false, [SecurityRoleType.EmployeeTechnician, SecurityRoleType.SubcontractorAdministrator, SecurityRoleType.SubcontractorUser], existing)
        );
    }

    public getEmployeeRoles(existing: () => RoleEntity[] = () => []): CoreDataSearcher<RoleEntity> {
        return this.getSearcher(
            'EmployeeRoles',
            () => new CoreDataSearcher<RoleEntity>(this.http, this.api + '/picker/roles/Employee', true, existing)
        );
    }

    public getSubcontractorRoles(existing: () => RoleEntity[] = () => []): CoreDataSearcher<RoleEntity> {
        return this.getSearcher(
            'SubcontractorRoles',
            () => new CoreDataSearcher<RoleEntity>(this.http, this.api + '/picker/roles/Subcontractor', true, existing)
        );
    }
    public getClientRoles(existing: () => RoleEntity[] = () => []): CoreDataSearcher<RoleEntity> {
        return this.getSearcher(
            'ClientRoles',
            () => new CoreDataSearcher<RoleEntity>(this.http, this.api + '/picker/roles/Client', true, existing)
        );
    }

    public getAssetTypeSearch(existing: () => AssetType[] = () => []): CoreDataSearcher<AssetType> {
        return this.getSearcher(
            'AssetTypeSearch',
            () => new CoreDataSearcher<AssetType>(this.http, this.api + '/asset/types', true, existing)
        );
    }
}
